module.exports = __webpack_public_path__ + "resources/img/bg_cover_service.caa92dbb61369c7143d0ce80384d926c.png";